import { render, staticRenderFns } from "./tmc-courier-data-modal.vue?vue&type=template&id=7590104f&scoped=true&"
import script from "./tmc-courier-data-modal.js?vue&type=script&lang=js&"
export * from "./tmc-courier-data-modal.js?vue&type=script&lang=js&"
import style0 from "./tmc-courier-data-modal.scss?vue&type=style&index=0&id=7590104f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7590104f",
  null
  
)

export default component.exports